var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-text',{staticClass:"value-display",style:(_vm.containerStyle)},[_c('div',{staticClass:"value-display__value",style:(_vm.valueStyle)},[_vm._v(" "+_vm._s(_vm.displayValue)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }